import { createSlice } from "@reduxjs/toolkit";

const snackSlice = createSlice({
  name: "snack slice",
  initialState: {
    message: "",
    severity: "",
    status: false,
    progress: 100,
  },
  reducers: {
    setSnackbar: (state, { payload }) => {
      console.log(state, "asdf");
      state.message =
        payload.message != undefined
          ? JSON.stringify(payload.message).replaceAll(`"`, "")
          : "500 Internal Error";
      state.severity = payload.severity || "error";
      state.status = true;
      state.autoHideDuration = payload.autoHideDuration || 5000;
    },
    closeSnackbar: (state, { payload }) => {
      state.status = false;
      state.progress = 100;
    },
    decreaseProgress: (state, { payload }) => {
      if (payload > -10 && state.status == true) {
        state.progress = state.progress - 10;
      } else {
        // state.progress = 100;
        state.status = false;
      }
    },
    resetProgress: (state, { payload }) => {
      state.progress = 100;
    },
  },
});
export const { setSnackbar, closeSnackbar, decreaseProgress, resetProgress } =
  snackSlice.actions;
export default snackSlice.reducer;
